"use client";

import { useEffect, useMemo, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";

const SCRIPT_SRC_BASE = "https://app.termly.io";

export default function TermlyCMP({
  autoBlock = true,
  masterConsentsOrigin,
  websiteUUID,
}) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const scriptSrc = useMemo(() => {
    const url = new URL(`${SCRIPT_SRC_BASE}/resource-blocker/${websiteUUID}`);
    if (autoBlock) url.searchParams.set("autoBlock", "on");
    if (masterConsentsOrigin)
      url.searchParams.set("masterConsentsOrigin", masterConsentsOrigin);
    return url.toString();
  }, [autoBlock, masterConsentsOrigin, websiteUUID]);

  const isScriptAdded = useRef(false);

  useEffect(() => {
    if (isScriptAdded.current) return;

    const script = document.createElement("script");
    script.src = scriptSrc;
    script.async = true;
    script.dataset.name = "termly-banner-script";
    script.type = "text/javascript";

    document.head.appendChild(script);
    isScriptAdded.current = true;

    return () => {
      document.head.removeChild(script);
      isScriptAdded.current = false;
    };
  }, [scriptSrc]);

  useEffect(() => {
    if (typeof window !== "undefined" && window.Termly?.initialize) {
      window.Termly.initialize();
    }
  }, [pathname, searchParams]);

  return null;
}
